import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TableHead,
  CircularProgress,
  Box,
  IconButton,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";
import { del, get } from "src/utils/networkUtils";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import LobbyDeleteDialog from "src/components/lobby-admin/LobbyDeleteDialog";
import { getUserPermissions } from "src/utils/permissionsUtils";

export default function LobbyPage() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [open, setOpen] = useState(null);
  const [openId, setOpenId] = useState(null);
  const [rows, setRows] = useState([]);
  const [setOpenStageDialog] = useState(false);
  const [setStage] = useState(null);
  const [openDeleteLobbyDialog, setOpenDeleteLobbyDialog] = useState(null);
  const [deleteLobbyLoading, setDeleteLobbyLoading] = useState(false);
  const { isViewer } = getUserPermissions();

  useEffect(() => {
    setLoading(true);
    get(`/admin/lobby?offset=0&limit=1000`).then((response) => {
      if (response.success) setRows(response.lobbies);
      setLoading(false);
    });
  }, []);

  const handleCloseMenu = () => {
    setOpen(null);
    setOpenId(null);
  };

  const handleCloseLobbyDialog = () => {
    setOpenDeleteLobbyDialog(null);
  };
  const handleOpenEditStageDialog = (stageId) => {
    const stage = rows.find((item) => item.stageId === stageId);
    if (stage) {
      setStage(stage);
      setOpenStageDialog(true);
      setOpen(null);
      setOpenId(null);
    }
  };
  const handleSuccessLobbyDialog = async (lobby) => {
    console.log("lobby from props", lobby);
    setDeleteLobbyLoading(true);
    try {
      await del(`/admin/lobby/${lobby.lobbyId}`);
      setDeleteLobbyLoading(true);
      window.location.reload(true);
    } catch (e) {
      setDeleteLobbyLoading(false);
      console.log(e);
    }
  };

  const centerStyles = {
    display: "flex",
    alignItems: "center",
    gap: 1,
  };
  return (
    <>
      <Helmet>
        <title> Lobby </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Lobby
          </Typography>
          <Stack spacing={2} direction="row">
            <Button
              variant="contained"
              startIcon={<AddCircleIcon />}
              onClick={() => navigate("/dashboard/game-providers")}
            >
              Add New Game Title
            </Button>
            <Button
              variant="outlined"
              onClick={() => navigate("/dashboard/game-providers")}
            >
              View Games Titles
            </Button>
            <Button
              variant="contained"
              startIcon={<Iconify icon="eva:plus-outline" />}
              onClick={() => navigate("/dashboard/lobby/add")}
            >
              Create New Lobby
            </Button>
          </Stack>
        </Stack>

        <Card>
          {loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Scrollbar>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Title</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Created At</TableCell>
                      <TableCell align="right"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        {/* <TableCell component="th" scope="row">
                          {row.stageId}
                        </TableCell> */}
                        <TableCell component="th" scope="row">
                          {row.lobbyName}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.lobbyStatus ? (
                            <Box sx={centerStyles}>
                              Active
                              <Iconify
                                icon="eva:checkmark-circle-2-outline"
                                sx={{ color: "green" }}
                              />
                            </Box>
                          ) : (
                            <Box sx={centerStyles}>
                              Inactive
                              <Iconify
                                icon="eva:close-circle-outline"
                                sx={{ color: "red" }}
                              />
                            </Box>
                          )}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            {row.createdAt
                              ? moment(row.createdAt).format(
                                  "MM/DD/YYYY hh:mm A"
                                )
                              : ""}
                          </Box>
                        </TableCell>
                        {!isViewer && (
                          <TableCell component="th" scope="row">
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-around",
                              }}
                            >
                              <Button
                                variant="outlined"
                                onClick={() =>
                                  navigate("/dashboard/lobby/add", {
                                    state: { row },
                                  })
                                }
                                sx={{
                                  width: 130,
                                  height: 40,
                                }}
                              >
                                Edit
                              </Button>
                              <IconButton
                                size="small"
                                onClick={() => setOpenDeleteLobbyDialog(row)}
                              >
                                <DeleteIcon sx={{ color: "red" }} />
                              </IconButton>
                            </Box>
                          </TableCell>
                        )}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          )}
        </Card>
      </Container>

      {!isViewer && (
        <Popover
          open={Boolean(open)}
          anchorEl={open}
          onClose={handleCloseMenu}
          anchorOrigin={{ vertical: "top", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          PaperProps={{
            sx: {
              p: 1,
              width: 140,
              "& .MuiMenuItem-root": {
                px: 1,
                typography: "body2",
                borderRadius: 0.75,
              },
            },
          }}
        >
          <MenuItem onClick={() => handleOpenEditStageDialog(openId)}>
            <Iconify icon={"eva:edit-outline"} sx={{ mr: 2 }} />
            Edit
          </MenuItem>
        </Popover>
      )}

      {openDeleteLobbyDialog && (
        <LobbyDeleteDialog
          lobby={openDeleteLobbyDialog}
          isLoading={deleteLobbyLoading}
          onSuccessHandler={handleSuccessLobbyDialog}
          onClose={handleCloseLobbyDialog}
        />
      )}
    </>
  );
}
